import { renderIcon } from '@opallabs/kuiper'
import { styles } from './styles'

interface Props {
  isMobile: boolean
}

export const TwitterStreamFooter: React.FC<Props> = ({ isMobile }) => {
  const iconNamePrefix = `twitter-${isMobile ? 'mobile' : 'desktop'}-stream-`

  return (
    <ul css={styles.getTwitterIcons(isMobile)}>
      <li>
        {renderIcon(`${iconNamePrefix}reply`, {
          height: 15,
          width: 15,
          ariaMode: 'hidden',
        })}
      </li>
      <li>
        {renderIcon(`${iconNamePrefix}retweet`, {
          height: 12,
          width: 18,
          ariaMode: 'hidden',
        })}
      </li>
      <li>
        {renderIcon(`${iconNamePrefix}favorite`, {
          height: 14,
          width: 15,
          ariaMode: 'hidden',
        })}
      </li>
      <li>
        {renderIcon(`${iconNamePrefix}share`, {
          height: 15,
          width: 15,
          ariaMode: 'hidden',
        })}
      </li>
    </ul>
  )
}
